import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LucideAngularModule, Trash2, FileX } from 'lucide-angular';
import { ArticleListItem } from '../../../../core/models/knowledge-base.model';

export interface ArticleDeleteModalData {
  articles: ArticleListItem[];
}

export interface ArticleDeleteModalResult {
  changeSummary: string;
}

@Component({
  selector: 'app-article-delete-modal',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    LucideAngularModule
  ],
  templateUrl: './article-delete-modal.component.html',
  styleUrls: ['./article-delete-modal.component.scss']
})
export class ArticleDeleteModalComponent {
  readonly Trash2 = Trash2;
  readonly FileX = FileX;

  changeSummary = '';

  constructor(
    public dialogRef: MatDialogRef<ArticleDeleteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ArticleDeleteModalData
  ) {}

  getMessage(): string {
    const articleText = this.data.articles.length === 1 ? 'el artículo' : `${this.data.articles.length} artículos`;
    return `¿Está seguro que desea eliminar ${articleText}?`;
  }

  onConfirm(): void {
    const result: ArticleDeleteModalResult = { changeSummary: this.changeSummary.trim() };
    this.dialogRef.close(result);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * Verifica si hay identificadores para mostrar
   */
  hasIdentifiers(): boolean {
    return !!this.data.articles && this.data.articles.length > 0;
  }

  /**
   * Determina si se debe mostrar la lista completa o una lista acortada con scroll
   */
  shouldShowScrollableList(): boolean {
    return this.hasIdentifiers() && this.data.articles.length > 5;
  }
}